import { type Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '../environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.clientId,
    authority: environment.authorityUrl,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: environment.cacheLocation,
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning,
    },
  },
};

export const loginRequest = {
  scopes: ['User.Read'],
};
